import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CertifiersPage from './pages/CertifiersPage';

function Certifiers() {
  return (
    <Routes>
      <Route path="/" element={<CertifiersPage />} />
    </Routes>
  );
}

export default Certifiers;